import styled from 'styled-components'

export const AllProductLayoutWrapper = styled.div`

`